module.exports = __webpack_public_path__ + "img/skirt_1.d8a19a24.png";